import { SpotCalendarClockIcon } from '@tableau/icons/SpotCalendarClockIcon';
import React from 'react';

import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { SchedulesService } from '~src/schedule/resources/Schedules';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { ContentTypeFilterClause, ExplorableItemDefinition, SpaceDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { NavLocationSelectors } from '~src/spacesPlatform/selectors/NavigationStateSelectors';

export const ScheduleDefinition: ExplorableItemDefinition & SpaceDefinition<'schedule'> = {
  itemType: 'schedule',
  contentType: 'schedule',
  singularName: Messages.schedule,
  pluralName: Messages.schedules,
  emptyStateMessage: Messages.schedulesEmptyMessage,
  contentFilterKeys: [],
  defaultFilters: (_projectId: string) => {
    // if on site schedules page return a siteId filter
    const inServerArea = NavLocationSelectors.inServerArea(getAppStore().getState());
    if (!inServerArea) {
      const siteId: string = SessionSiteSelectors.siteId(getAppStore().getState());
      return {siteId: ServerFilterClauses.serverFilterClauses.siteId(siteId)};
    }
    return undefined;
  },
  cardComponent: GenericCard,
  listViewIconType: null,
  headerIconPath: () => imgPath('spaces_masthead_schedule.svg'),
  headerIconNode: () => <SpotCalendarClockIcon size={80} viewBox='0 0 80 80' style={{ width: 42, height: 42 }} alt='' />,
  filterClause: ServerFilterClauses.ContentType(['schedule']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return SchedulesService.all();
  },
  getContentInfo: () => {
  },
  contentSpaceUrl: () => '',
  supportedDisplayModes: ['list'],
};
